export default {
  'menu-manage.availability.title': '库存管理',

  'menu-manage.isFreeOnDishPreferenceWithNoOption.switch.label':
    '当操作【不要】的时候，带有价格的选项，均不收费(即，价格变为0)。',

  'menu-manage.tab.dishes': '菜品',
  'menu-manage.tab.customizations': '附加选项',

  'menu-manage.action.add-category': '新增分类',
  'menu-manage.action.add-dish': '新增菜品',

  'menu-manage.menu.title': '菜单设置',
  'menu-manage.menu.sort': '拖动项目来改变菜单排序',
  'menu-manage.menu.menu': '菜单',

  'menu-manage.reload-meals': '加载失败！ 点击此处重试',
  'menu-manage.loading-customizations': '加载中',

  'menu-manage.list-title.categories': '分类',
  'menu-manage.list-title.dish-items': '菜品',
  'menu-manage.list-title.customizations': '附加选项',
  'menu-manage.list-title.colorpicker': '菜品颜色选择',

  'menu-manage.price-switch': '价格自定义',
  'menu-manage.price': '价格',
  'menu-manage.dish-button-color': '菜品按钮颜色',

  'menu-manage.dish-preference.title': '菜品偏好设置',
  'menu-manage.dish-preference.associatedCustomizedOption': '已关联{count}个附加选项',
};
